/**
 * WebSocket-Anbindung für den Chat (Lobby und je Partie).
 *
 * Eine Verbindung, ein aktiver Kanal – wie bei `socket.ts`. Ein Kanalwechsel
 * meldet den alten Kanal ab, statt eine zweite Verbindung zu öffnen.
 */
import type { ChatMessageEntry } from './api';
import { createAuthedSocket } from './socketBase';

const authed = createAuthedSocket('/chat');
let currentChannel: string | null = null;
let currentHandler: ((message: ChatMessageEntry) => void) | null = null;

export function connectChat(channel: string, onMessage: (message: ChatMessageEntry) => void): void {
  currentHandler = onMessage;

  const previous = authed.get();
  if (previous && currentChannel && currentChannel !== channel) {
    previous.emit('unsubscribe', { channel: currentChannel });
  }
  currentChannel = channel;

  authed.connect(() => {
    const socket = authed.get();
    if (!socket) return;
    socket.off('message');
    if (currentHandler) socket.on('message', currentHandler);
    if (currentChannel) socket.emit('subscribe', { channel: currentChannel });
  });
}

/** `onAck` bekommt eine Rückmeldung bei Ablehnung, etwa durch das Ratenlimit. */
export function sendChatMessage(channel: string, body: string, onAck?: (ack: { ok: boolean; message?: string }) => void): void {
  authed.get()?.emit('send', { channel, body }, onAck);
}

export function disconnectChat(): void {
  const socket = authed.get();
  if (socket && currentChannel) socket.emit('unsubscribe', { channel: currentChannel });
  authed.disconnect();
  currentChannel = null;
  currentHandler = null;
}

export function chatConnected(): boolean {
  return authed.connected();
}
